export default __webpack_public_path__ + "static/media/share_icon.959df390.svg";